import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, CheckCircle, XCircle, Clock, X } from 'lucide-react';
import { getCompanyUsage } from '../../api/companies';

export function TrialBanner() {
  const navigate = useNavigate();
  const [usage, setUsage] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    getCompanyUsage().then(setUsage).catch(() => {});
  }, []);

  if (!usage || dismissed) return null;

  const { subscription_status, trial_days_left, plan } = usage;

  // Aktif ödeme planı — yeşil bar
  if (subscription_status === 'active') return null;

  // Suspended — kırmızı tam ekran engel
  if (subscription_status === 'suspended') {
    return (
      <div className="bg-red-600 text-white px-4 py-3 flex items-center gap-3 shrink-0">
        <XCircle size={18} />
        <div className="flex-1">
          <p className="text-sm font-semibold">Hesabınız askıya alındı</p>
          <p className="text-xs text-red-200">
            <button onClick={() => navigate('/billing')} className="underline hover:text-white">Ödeme bilgilerinizi güncelleyin →</button>
          </p>
        </div>
      </div>
    );
  }

  // Cancelled
  if (subscription_status === 'cancelled') {
    return (
      <div className="bg-slate-700 text-white px-4 py-2.5 flex items-center gap-3 shrink-0">
        <XCircle size={16} />
        <p className="text-sm">Aboneliğiniz iptal edildi. <button onClick={() => navigate('/billing')} className="underline font-medium hover:text-white">Tekrar aktifleştirin →</button></p>
      </div>
    );
  }

  // Trial
  if (subscription_status === 'trial') {
    const isUrgent = trial_days_left <= 5;
    const isWarning = trial_days_left <= 15;
    const expired = trial_days_left <= 0;

    const bg = expired
      ? 'bg-red-600'
      : isUrgent
        ? 'bg-red-500'
        : isWarning
          ? 'bg-amber-500'
          : 'bg-blue-500';

    const icon = expired ? <XCircle size={16} /> : isUrgent ? <AlertTriangle size={16} /> : <Clock size={16} />;

    return (
      <div className={`${bg} text-white px-4 py-2 flex items-center gap-3 shrink-0 text-sm`}>
        {icon}
        <p className="flex-1">
          {expired ? (
            <span>Deneme süreniz doldu. Kullanmaya devam etmek için{' '}
              <button onClick={() => navigate('/billing')} className="underline font-semibold hover:text-white/80">bir plan seçin</button>.
            </span>
          ) : (
            <span>
              Deneme süreniz <strong>{trial_days_left} gün</strong> sonra bitiyor.{' '}
              <button onClick={() => navigate('/billing')} className="underline font-semibold hover:text-white/80">Plan seçin →</button>
            </span>
          )}
        </p>
        {!expired && (
          <button onClick={() => setDismissed(true)} className="p-1 hover:bg-white/20 rounded">
            <X size={14} />
          </button>
        )}
      </div>
    );
  }

  return null;
}
